import { useState } from 'react';
import { AnswerOption, AnswerQuestion } from '../../types/data';
import { useAppDispatch } from 'src/hooks/redux';
import { createAnswerRequest, updateAnswerRequest } from '../../store/data-main/data-main';
import { Quarter } from '../../types/data';

const questionArray: AnswerOption[] = ['Да', 'Нет', 'N/A'];

type QuestionType = {
  data: AnswerQuestion;
  requirementId: number;
  factory: number;
  quarter: Quarter;
  year: number;
  group?: number;
  direction?: number;
  gopId?: number;
  isCompleted: boolean;
  onCreateQuestionnaire: () => void;
};

function Question(props: QuestionType) {
  const { data, requirementId, factory, quarter, year, group, direction, gopId, isCompleted, onCreateQuestionnaire } = props;
  const [active, setActive] = useState<boolean>(false);
  const [question, setQuestion] = useState<AnswerOption>(data.answer);

  const dispatch = useAppDispatch();

  const filterQuestion = questionArray.filter((el) => el !== question);

  const handleChangeQuestion = (newAnswer: AnswerOption) => {
    if (data.answerId === null) {
      dispatch(createAnswerRequest({
        answer: newAnswer,
        quarter: quarter,
        year: year,
        factory: factory,
        department: data.departmentId,
        requirement: requirementId,
        group: group,
        direction: direction,
        gop: gopId
      }));
    } else {
      dispatch(updateAnswerRequest({
        id: data.answerId,
        answer: newAnswer
      }));
    }
  };

  return (
    <div
      className={`inline-flex w-full items-center gap-2 text-center ${isCompleted && 'pointer-events-none opacity-75'}`}
    >
      <div
        className="relative w-[48px] grow cursor-pointer rounded-sm border px-2 py-1 hover:border-[#8899A8]"
        onClick={() => setActive((prev) => !prev)}
      >
        <span>{question}</span>

        {active && (
          <ul className="absolute left-[-1px] right-[-1px] top-[calc(100%+2px)] z-10 flex flex-col gap-0.5">
            {filterQuestion.map((el, index) => (
              <li
                className="cursor-pointer rounded-sm border bg-white px-2 py-1 hover:border-[#8899A8]"
                key={index}
                onClick={() => {
                  setQuestion(el);
                  setActive(true);
                  handleChangeQuestion(el);
                  onCreateQuestionnaire();
                }}
              >
                {el}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default Question;
